

import TrackOrderItem from './components/cart/TrackOrderItem';

import { getFromApi } from '../lib/api';
import LatLon from '../lib/latlon';
import { uuidv4, formatPrice } from '../lib/utils'

import useTranslations from "../providers/useTranslations";
import { BusinessContext } from '../providers/BusinessContext';
import { CartContext } from '../providers/CartContext';
import { DeliveryMap } from './order/order_progress';

function TrackOrder(props) {

  let d = new Date()
  const [timer, setTimer] = React.useState(null)
  const [confirmed, setConfirmed] = React.useState(null)
  const [deliveryChargeRange, setChargeRange] = React.useState(null)
  const [deliverType, setDeliverType] = React.useState(null)
  const [readyIn, setReadyIn] = React.useState(30)
  const [order, setOrder] = React.useState({
    Business: {},
    Location: { latlng: "7.117969, -73.109473" },
    deliveryData: {},
    items: [],
    tstamp: d.toISOString()
  })

  const forceUpdate = React.useReducer(() => ({}), {})[1]

  // display the location of the delivery
  const [delivery, setDelivery] = React.useState(null)
  const [driver, setDriver] = React.useState(null)

  const { applyDiscount, isDiscountActive, discountMessage } = React.useContext(CartContext);

  const { locationConfigValue } = React.useContext(BusinessContext);

  const timerRef = React.useRef(null)
  timerRef.current = timer

  const orderRef = React.useRef(null)
  orderRef.current = order

  const deliveryRef = React.useRef(null)
  deliveryRef.current = delivery

  const driverRef = React.useRef(null)
  driverRef.current = driver

  const { tr, getTranslations /* , , locale, translations, setLocale */ } = useTranslations();

  function _formatDate(timestamp, datetime) {
    const options = { hour: '2-digit', minute: '2-digit' }
    const df = new Intl.DateTimeFormat('es-CO', options)

    let dt = timestamp != null ? new Date(timestamp) : Date.parse(datetime)

    return df.format(dt)
  }

  const _checkOrderUpdates = () => {
    //console.log('_checkOrderUpdates', orderRef.current)

    getFromApi("/api/v1/order/" + orderRef.current.id, {}, (response) => {
      let order = orderRef.current
      let orderObj = response.result

      //console.log('_checkOrderUpdates order', response.result, order)

      if (orderObj.status !== order.status /* && order.deliverType === "delivery" */) {
        // the order has changed
        console.log("order changed", order.status, " --> ", orderObj.status)

        order.status = orderObj.status

        if (orderObj.status === "preparing") {
          // confirmed
          setConfirmed(new Date())
        }
        forceUpdate()
      } else if (orderObj.status === "preparing") {
        // we missed the update to preparing
        console.log("set confirmed to now")
        setConfirmed(new Date())
      }

      // check the delivery and driver and download if we don't have them
      if (!deliveryRef.current && orderObj.deliveryId > 0) {
        getFromApi(`/api/v1/delivery/${orderObj.deliveryId}`, {}, (response) => {
          setDelivery(response.result)
          deliveryRef.current = response.result

          if (!driverRef.current && orderObj.driverId > 0) {

            if (response.result.driver && response.result.driver.id > 0) {
              setDriver(response.result.driver)
              driverRef.current = response.result.driver
            } else {
              getFromApi(`/api/v1/driver/${orderObj.driverId}`, {}, (response) => {
                setDriver(response.result)
                driverRef.current = response.result
              },
                (error) => {
                  console.log("can't get driver", error.responseText)
                })
            }
          }

        },
          (error) => {
            console.log("can't get delivery", error.responseText)
          })
      } else if (!driverRef.current && orderObj.driverId > 0) {
        getFromApi(`/api/v1/driver/${orderObj.driverId}`, {}, (response) => {
          setDriver(response.result)
          driverRef.current = response.result
        },
          (error) => {
            console.log("can't get driver", error.responseText)
          })
      }
    },
      (error) => {

      })

  }

  const orderStatusComponent = (order, stage) => {
    let next = <span>{tr("NEXT")}</span>
    let done = <i className="icofont-check-circled icofont-2x text-success" />
    let rejected = <i className="icofont-close-circled icofont-2x text-danger" />

    if (order.status === "rejected" || order.status === "auto_rejected") {
      return rejected
    }

    if (stage === "confirmed") {
      if (order.status === "new") {
        return next
      } else {
        return done
      }
    } else if (stage === "ready") {
      return (<span>{tr("LATER")} (ET : {readyIn}min)</span>)

    } else if (stage === "dispatched") {
      if (order.status === "ready") {
        return next
      } else if (order.status === "dispatched") {
        return done
      }

      // subtract the confirmed time from the current time
      return (<span>{tr("LATER")}</span>)
    }

    return <span></span>
  }

  const orderStatusSection = (order) => {

    if (order.status === "rejected" || order.status === "auto_rejected") {

    return (

      <div className="bg-white p-4 shadow-lg mt-2">
        <div className="row text-center">
          <div className="col" >
            <i className="icofont-tasks icofont-3x text-info" />
            <p className="mt-1 font-weight-bold text-dark mb-0">{tr("Order Received")}</p>
            <small className="text-info mb-0"><i className="icofont-check-circled icofont-2x text-success" /></small>
          </div>
          <div className="col" >
            <i className="icofont-close-circled icofont-3x text-danger" />
            <p className="mt-1 font-weight-bold text-dark mb-0">{tr("Order Rejected")}</p>
            <small className="text-success mb-0">{orderStatusComponent(order, "confirmed")}</small>
          </div>

        </div >
      </div>
    )
    }


    return (

      <div className="bg-white p-4 shadow-lg mt-2">
        <div className="row text-center">
          <div className="col" >
            <i className="icofont-tasks icofont-3x text-info" />
            <p className="mt-1 font-weight-bold text-dark mb-0">{tr("Order Received")}</p>
            <small className="text-info mb-0"><i className="icofont-check-circled icofont-2x text-success" /></small>
          </div>
          <div className="col" >
            <i className="icofont-check-circled icofont-3x text-success" />
            <p className="mt-1 font-weight-bold text-dark mb-0">{tr("Order Confirmed")}</p>
            <small className="text-success mb-0">{orderStatusComponent(order, "confirmed")}</small>
          </div>
          <div className="col" >
            <i className="icofont-delivery-time icofont-3x text-primary" />
            <p className="mt-1 font-weight-bold text-dark mb-0">{tr("Order Picked Up")}</p>
            <small className="text-primary mb-0">
              {orderStatusComponent(order, "dispatched")}
            </small>
          </div>
        </div >
      </div>
    )
  }

  React.useEffect(() => {

    getTranslations()

    let po = localStorage.getItem('pendingOrder')

    //console.log("pending order", po)

    if (po) {
      let orderObj = JSON.parse(po)

      // check this is a pending order from Thanks page, not history
      if (!orderObj.deliveryData) {
        orderObj.deliveryData = {
          name: orderObj.name,
          email: orderObj.email,
          phone: orderObj.phone
        }
        if (orderObj.deliverType === "delivery") {
          orderObj.deliveryData.address = orderObj.destination
        }
      }

      setOrder(orderObj)
      setChargeRange(locationConfigValue(orderObj.Business.Configs, orderObj.Location.id, "deliveryChargeRange", null))
      setDeliverType(orderObj.deliverType)

      //console.log("pending order", orderObj)
    } else {
      // load the last order
      let hdata = localStorage.getItem('orderHistory');
      let addrData = localStorage.getItem('addressList');
      let hd = []
      let max = 0
      let addrList

      if (hdata) {
        hd = JSON.parse(hdata);
      }

      if (hd.length > 0) {
        hd.forEach((o) => max = Math.max(max, o.id))

        // load the order
        getFromApi(`/api/v1/order/${max}/with_business_and_location`, {}, (response) => {
          let orderObj = response.result

          orderObj.deliveryData = {
            name: orderObj.name,
            email: orderObj.email,
            phone: orderObj.phone
          }
          if (orderObj.deliverType === "delivery") {
            orderObj.deliveryData.address = orderObj.destination
            orderObj.deliveryData.title = 'Casa'

            // determine the address title
            if (addrData) {
              addrList = JSON.parse(addrData)
              addrList.forEach((a) => {
                let parts = orderObj.destination.split(",")
                if (a.address.includes(parts[0])) {
                  orderObj.deliveryData.title = a.title
                }
              })
            }
          }

          setOrder(orderObj)
          setDeliverType(orderObj.deliverType)
          setChargeRange(locationConfigValue(orderObj.Business.Configs, orderObj.Location.id, "deliveryChargeRange", null))

        },
          (error) => {

          })

      } else {
        console.log("no order history")
        window.location.href = "/"
      }

      //console.log("no order")
    }

    let timer = setInterval(() => {
      // check for updates from the API server
      _checkOrderUpdates()
    }, 30000)

    setTimer(timer)


    return () => {
      if (timerRef.current !== null) {
        console.log("clear interval")
        clearInterval(timerRef.current)
        setTimer(null)
      } else {
        console.log("no interval to clear")
      }

    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [])

  let latlon = LatLon.fromString(order.Location.latlng)

  const _deliveryMap = (order) => {

    let driver = driverRef.current

    if (delivery &&
      order.deliverType === 'delivery' &&
      order.status === OrderStatus.Dispatched
    ) {
      let dlat = driver ? driver.latitude : delivery.pickup.latitude
      let dlng = driver ? driver.longitude : delivery.pickup.longitude
      let lat = latitude || dlat
      let lng = longitude || dlng

      //console.log("delivery map lat/lng", lat, lng, latitude, longitude, dlat, dlng)

      return <DeliveryMap latitude={lat} longitude={lng}
        delivery={delivery}
        driver={driver || {}}
        title={tr("Delivery driver location")} onMapClick={(position) => {
          console.log("map clicked at ", position)
        }} />

    }
    return <></>
  }

  const _deliveryCostElement = () => {
    if (order.shippingcost > 0) {
      return <p className="mb-1">{tr("Estimated Delivery Fee")}
        <span className="text-info ml-1">
          <i className="icofont-info-circle" title={tr("Actual cost varies")} />
        </span>
        <span className="float-right text-dark">{formatPrice(order.shippingcost)}</span>
      </p>
    }

    return <></>
  }

  const deliveryCostElement = () => {

    if (order.shippingcost > 0) {
      return <span className="float-right text-dark"> + {formatPrice(order.shippingcost)}</span>
    }

    return <></>
  }

  const totalWithDiscountElement = () => {
    let newCost = applyDiscount(order.itemscost, window.menu)

    //console.log("totalWithDiscountElement",order.deliverType, order.itemscost, order.packingcost, order.shippingcost,  newCost)

    if (order.deliverType && order.deliverType !== "table") {

      return <h6 className="font-weight-bold mb-0 text-black totalWithDiscountElement">
        {tr("TO PAY")} <span className="float-right discounted-cost">{formatPrice(newCost + order.packingcost)}</span></h6>
    }

    return <h6 className="font-weight-bold mb-0 text-black totalWithDiscountElement">
      {tr("TO PAY")} <span className="float-right discounted-cost">{formatPrice(newCost)}</span></h6>
  }

  //console.log("render with", order, latlon)

  return (
    <section className="section bg-white osahan-track-order-page position-relative">

      <div className="container pt-5 pb-5">
        <div className="row d-flex align-items-center">
          <div className="col-md-6 text-center pb-4">
            {_deliveryMap(order)}
          </div>
          <div className="col-md-6">
            <div className="bg-white p-4 shadow-lg mb-2 track-order-header">
              <div className="mb-2 track-order-number"><small>{tr("Order")} #{order.orderNumber}
                {/*  <a className="float-right font-weight-bold" href="#"><i className="icofont-headphone-alt" /> HELP</a> */}

              </small></div>
              <h6 className="mb-1 mt-1 track-business-name">{/* <a href="/detail" className="text-black">{order.Business.name}
                </a> */}
                {order.Business.name}
              </h6>
              <p className="text-gray mb-0 track-order-summary"><i className="icofont-clock-time" /> {_formatDate(null, order.tstamp)} | {order.items.length} {tr("Items")} | ${order.totalcost}</p>
            </div>

            <div className="bg-white p-4 shadow-lg">
              <div className="osahan-track-order-detail po">
                <h5 className="mt-0 mb-3">{tr("Order Details")}</h5>
                <div className="row" >
                  <div className="col-md-5">
                    <small>{tr("FROM")}</small>
                    <h6 className="mb-1 mt-1"><i className="icofont-food-cart" /> {order.Business.name}
                    </h6>
                    <p className="text-gray mb-5">{order.Location.address}, {order.Location.city}</p>
                    <small>{tr("DELIVER TO")}</small>
                    <h6 className="mb-1 mt-1"><span className="text-black"><i className="icofont-map-pins" /> {order.deliveryData.title}
                    </span>
                    </h6>
                    <p className="text-gray mb-0 track-order-address">{order.deliveryData.address}, {order.deliveryData.city}
                    </p>
                  </div>
                  <div className="col-md-7">
                    <div className="mb-2"><small><i className="icofont-list" /> {order.items.length} {tr("Items")}</small></div>

                    {order.items.map((item, index) => {
                      return (
                        <TrackOrderItem
                          key={'item ' + index}
                          icoIcon='ui-press'
                          iconClass='text-danger food-item'
                          title={item.name}
                          item={item}

                          itemName={item.name}
                          cartItem={item}
                          price={item.chosenPrice || item.price}
                          priceUnit="$"
                          id={item.id}
                          quantity={item.quantity}
                          show={true}
                          minValue={0}
                          maxValue={7}
                          formatPrice={formatPrice}
                        />
                      )
                    })}

                    <hr />
                    <p className="mb-0 font-weight-bold text-black">{tr("TOTAL BILL")}
                      <span className="float-right text-secondary">{formatPrice(order.totalcost)}</span></p>
                    {/*  <p className="mb-0 text-info"><small>Paid via Credit/Debit card
                      <span className="float-right text-danger">$620 OFF</span></small>
                    </p> */}
                    {_deliveryCostElement()}

                    {order.packingCost > 0 && order.deliverType && order.deliverType !== "table" &&
                      <p className="mb-1">{tr("Packaging charge")}
                        <span className="text-info ml-1">
                          <i className="icofont-info-circle" title={tr("Additional charges for packaging material")} />
                        </span>
                        <span className="float-right text-dark">{formatPrice(order.packingCost)}</span>
                      </p>
                    }

                    {totalWithDiscountElement()}

                    {deliveryCostElement()}

                  </div>
                </div >
              </div>
            </div>
            {orderStatusSection(order)}
          </div>
        </div >
      </div >
    </section>
  );

}


export default TrackOrder;